




import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import UserService from '../../../services/UserService'
import OrganisationTagService from '../../../services/OrganisationTagService'

import OrganisationService from '../../../services/OrganisationService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import Form from '../../../components/simple/form/Form'
import FormField from '../../../components/simple/formField/FormField'
import Select from '../../../components/simple/input/Select'
import CheckBox from '../../../components/simple/input/CheckBox'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'
import PulseLoader from 'react-spinners/PulseLoader.js'
import RoleService from '../../../services/RoleService.js'

function Access (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [userHasChangedRole, setUserHasChangedRole] = useState(false)

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')



      // Initialize userDetails otherwise we get error
      // A component is changing an uncontrolled input of type text to be controlled
      const [userDetails, setUserDetails] = useState({
        organisation: 0,
        role: 0,
        // username: '',
        firstName: '',
        lastName: '',
        email: '',
        jobTitle: ''
      })

      // Contains array of org objects for populating the School dropdown
      const [orgValues, setOrgValues] = useState([])

      const [saveLocked, setSaveLocked] = useState(false)


      // Contains an Organisation object that has been selected from the School dropdown
      const [selectedOrg, setSelectedOrg] = useState(null)

      // Contains array of role objects for populating the Role dropdown
      const [roleValues, setRoleValues] = useState([])

      const [originalRole, setOriginalRole] = useState(null)

      const [safeguardingLeads, setSafeguardingLeads] = useState([])
      const [originalSafeguardingLeads, setOriginalSafeguardingLeads] = useState([])


      const [isBlocked, setIsBlocked] = useState(false)

    const params = useParams()
    const userId = params.userid


    const getRoles = async () => {
        // don't do anything if we don't have a selected org
        if (!selectedOrg?.id) { return }

        const roles = await OrganisationService.getRolesForOrg(apiToken, selectedOrg.id)
        if (roles?.error) {
          NotificationService.error(roles.error)
        } else if (roles?.data) {

          for (let role of roles.data) {
            if ( role.name === 'Admin') {
              role.name = 'Full User'
            } else if (role.name === 'Standard') {
              role.name = 'Restricted User'
            }
          }
          setRoleValues(roles.data)
        }
      }


    // Submit form values
    const submitForm = async (values) => {
      if (userId === 'new') {

        setSaveLocked(true)

        var userAdded = await UserService.inviteUser(apiToken, values)
        if (userAdded?.error) {
          // If the error message is about a user limit, display it
          var errorStr = 'Error saving the user, please try again.'
          if (userAdded?.error?.errorType === 'userlimit') {
            errorStr = userAdded.error.error
          }
          NotificationService.error(errorStr)
        } else {
          NotificationService.info('User added')
          navigate('/users', { message: userAdded.data.message })
        }
      } else {

        var userUpdated = await UserService.updateUser(apiToken, values)
        if (userUpdated?.error) {
          NotificationService.error('Error saving the user, please try again - ', userUpdated?.error)
          return
        }

        // if the role has changed, update the role
        if (userHasChangedRole && values.role) {
          var roleUpdated = await RoleService.addRoleUser(apiToken, null, values.role, values.id)
          if (roleUpdated?.error) {
            NotificationService.error('Error saving the user, please try again - ', roleUpdated?.error)
            return
          }
        }

        // if the safeguarding leads have changed, update the tags
        if (JSON.stringify(safeguardingLeads) !== JSON.stringify(originalSafeguardingLeads)) {
          await saveSafeguardingLeads(safeguardingLeads)
        }

        NotificationService.success('User updated successfully')
        navigate('/users', { message: 'User updated successfully' })

      }
    }

    const getUserDetails = async (userId) => {
        const params = {
          fields: 'id,firstName,lastName,email,blocked,jobTitle',
          type: 'user'
        }

        const response = await UserService.getUser(apiToken, params, userId)
        if (response?.error) {
          NotificationService.error(response.error)
        } else {
          var newDetails = {
            ...userDetails,
            ...response.data[0]
          }
          setUserDetails(newDetails)
        }
      }

    const getRoleForUser = async () => {
      // don't do anything if the user is new
      if (userId === 'new') {
        return
      }

      // don't do anything if we don't have any roles
      if (!roleValues.length) {
        return
      }

      // don't do anything if we don't have a selectedOrg
      if (!selectedOrg.id) {
        return
      }

      const roles = await RoleService.getRoleForUser(apiToken, userId)
      if (roles?.error) {
        NotificationService.error(roles.error)
      } else if (roles?.data) {
        // get the role that belongs to the current organisation
        var roleForThisOrg = roles.data.find(role => parseInt(role.organisation) === parseInt(selectedOrg.id))
        if (roleForThisOrg) {
          setUserDetails({
            ...userDetails,
            role: roleForThisOrg.id
          })

          setOriginalRole(roleForThisOrg.id)

        }
      }
    }

    // Go Back
    const goBack = () => {
      navigate(-1)
    }

    useEffect(() => {
      // get the current user's role


      if (selectedOrg) {
        getRoleForUser()
      }
    }, [roleValues, selectedOrg, userId])

    useEffect(() => {

      getUserDetails(userId).then(() => {
        if (selectedOrg) {
          getRoles()
        }
      })
    }, [selectedOrg, userId])

    useEffect(() => {
      setIsBlocked(userDetails.blocked)
    }, [userDetails?.blocked])

    // useEffect(() => {
    //   let unmounted = false

    //   if (!unmounted) {
    //     if (userId !== 'new') {
    //       getUserDetails(userId)
    //     }
    //   }
    //   return () => { unmounted = true }
    // }, [orgValues, userId])

    useEffect(() => {
      let unmounted = false

      const getOrganisations = async () => {
        var organisations = LocalStorageService.get('userOrganisations')
        if (organisations?.error) {
          NotificationService.error(organisations.error)
        } else {
          setOrgValues(organisations)
          setSelectedOrg(activeOrg)

          // make sure the organisations comes back as an array
          var toSave = {
            ...userDetails,
            organisation: activeOrg.id
          }
          setUserDetails(toSave)
        }
      }
      if (!unmounted) {
        getOrganisations()
      }
      return () => { unmounted = true }
    }, [])


    const saveSafeguardingLeads = async (leads) => {
      const params = {
        orgId: activeOrg.id
      }

      const tagsToSubmit = [{
        organisation: activeOrg.id,
        type: 'besmart',
        key: 'safeguardingLeads',
        value: JSON.stringify(leads)
      }]

      let response = await OrganisationTagService.set(apiToken, params, tagsToSubmit)
      if (response?.error) {
        NotificationService.error('Error saving enhanced permissions: ', response.error)
      } else {
        NotificationService.success('Enhanced permissions updated successfully')
      }
      setOriginalSafeguardingLeads(leads)
    }

    const getSafeguardingLeads = async () => {

      const params = {
        fields: 'type,key,value',
        limit: 100,
        orgId: activeOrg.id
      }

      const where = {
        type: 'besmart'
      }

      const organisationTags = await OrganisationTagService.get(apiToken, params, where)
      if (organisationTags) {
        organisationTags.forEach(tag => {
          if (tag.key === 'safeguardingLeads') {
            try {
                let sLeads = JSON.parse(tag.value)
                setSafeguardingLeads(sLeads)
                setOriginalSafeguardingLeads(sLeads)
              } catch (err) {
                console.error(err)
              }
          }
        })
      }

    }

    useEffect(() => {
      getSafeguardingLeads()
    }, [])


  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box direction='row' gap='medium' margin={{ top: 'small', bottom: 'larmediumge' }}>
    <Box background='white' direction='column' gap='small'  border={{ color: '#eee', side: 'right' }} pad='small' flex='grow'>

      <Box
        gap='small'
        round='small'
      >
        <>

        <Form
          //   validate='blur'
          onChange={nextValue => {
            setUserDetails(nextValue)
          }}
          onSubmit={({ value: nextValue }) => {
            submitForm(nextValue)
          }}
          value={userDetails}
        >
                      <Box direction='row-responsive' gap='medium' margin={{ bottom: 'medium', top: 'none'}}>

                        <FormField
                          label={'System Role:'}
                          name='role'
                          required
                        >
                          <Select
                            id='role'
                            name='role'
                            labelKey='title'
                            placeholder='System Role'
                            options={roleValues}
                            onChange={option => {
                              setUserHasChangedRole(true)
                            }}
                            valueKey={{ key: 'id', reduce: true }}
                          />
                        </FormField>

                        <FormField
                          label='Enhanced Permissions'
                          name='permissions'
                        >
                          <CheckBox
                            name='permissions'
                            label='Access to the Analytics, System Users, and all Incidents'
                            checked={safeguardingLeads.map(lead => lead.email).includes(userDetails.email)}
                            onChange={(event) => {


                              setSafeguardingLeads(prevLeads => {
                                if (event?.target?.checked) {
                                  return [...prevLeads, { email: userDetails.email }]
                                } else {
                                  return prevLeads.filter(lead => lead.email !== userDetails.email)
                                }
                              })
                            }}
                          />

                        </FormField>


                      </Box>

                      <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />


                      <FormField
                          label='Block Access'
                          name='blocked'
                        >
                          <CheckBox
                            name='blocked'
                            label='Block this user from accessing the system. This will not affect any existing incidents or data that they have entered.'
                            checked={isBlocked}
                            onChange={(event) => {
                              setIsBlocked(event?.target?.checked)
                            }}
                          />

                        </FormField>



                      <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />

                      <Box direction='row' justify='between' margin={{ top: 'medium' }}>
                        <ActionButton label='< Back' onClick={() => goBack()} secondary />
                        <ActionButton type='submit' label={(userId === 'new' ? 'Send Invite' : 'Save')} primary disabled={saveLocked} />
                      </Box>
                    </Form>
        </>
      </Box>
    </Box>

  </Box>)
}
export default Access
